import styled from 'styled-components';

import COLORS from '@mlb/react-patterns/style/universal.color';
import SkeletonPattern from '@mlb/react-patterns/components/Skeleton/skeleton.tsx';
import { styledListWrapper, styledListItem } from '@mlb/react-patterns/components/TypeAhead/typeAhead.style';
import { media } from '@mlb/react-patterns/style/helpers/media.ts';

import TypeaheadBase from '../TypeaheadBase';
import { Link } from '../TypeaheadBase/TypeaheadBase.styles';

export const Skeleton = styled(SkeletonPattern)`
  width: calc(100% - 32px);
  height: 32px;
  margin: 15px 16px;
  ${media.lgmin`
    width: calc(100% - 52px);
    margin: 15px 20px 15px 32px;
  `}
`;

export const Typeahead = styled(TypeaheadBase)`
  padding: 15px 16px;
  input {
    &.left {
      padding-left: 30px;
    }
    &.right {
      padding-right: 30px;
    }
  }
  ${styledListWrapper} {
    top: 60px;
    left: 0;
    padding: 0px 16px;
    z-index: 2;
    ${styledListItem} {
      padding: 0;
      ${Link} {
        padding: 4px;
      }
      &[data-type="label"] {
        padding: 4px 0;
      }
      &.tag_item {
        display: inline-block;
        margin: 0 10px 10px 0;
        &:hover {
          background: ${COLORS.transparent};
        }
      }
    }
    ${media.lgmin`
      padding: 0px 16px 0px 32px;
    `}
  }
  ${media.lgmin`
    padding: 15px 20px 15px 32px;
  `}
`;
